export default "__VITE_PUBLIC_ASSET__be8ad54e__"